import AircraftCategoryPage from "@/components/AircraftCategoryPage";

const AircraftList = () => (
  <AircraftCategoryPage title="Aeronave"/>
);

export default AircraftList;
